import { BrowserRouter, Routes, Route } from "react-router-dom";

import Login from "../Pages/Login/Login";
import Register from "../Pages/RegisterFreelancer/Register";
import RegisterCompany from "../Pages/RegisterCompany/RegisterCompany";
import PrivateJobPage from "../Pages/DashboardCompany/Components/PrivateJobPage/PrivateJobPage";
import ForgotPassword from "../Components/ForgotPassword/Forgotpassword";
import ResetPassword from "../Components/ResetPassword/ResetPassword";
import PainelProfissional from "../Components/PainelProfissional/PainelProfissional";

// Dashboard
import DashboardFreelancer from "../Pages/DashboardFreelancer/DashboardFreelancer";
import DashboardCompany from "../Pages/DashboardCompany/DashboardCompany";
import Earnings from "../Pages/DashboardFreelancer/Components/Earnings/Earnings";
import DashboardAdmin from "../Pages/DasboardAdmin/DashboardAdmin";

import ProtectedRoute from "./ProtectedRoute";
import AdminRoute from "./AdminRoute";
import PublicOnlyRoute from "./PublicOnlyRoute";
import BackNavigationHandler from "../Components/BackNavigationHandler/BackNavigationHandler";

// Páginas legais
import TermosDeUso from "../Pages/TermosDeUso/TermosDeUso";
import PoliticaDePrivacidade from "../Pages/PoliticaDePrivacidade/PoliticaDePrivacidade";

export default function AppRoutes() {
    return (
        <BrowserRouter>
            <BackNavigationHandler />

            <Routes>

                {/* =====================================================
                    PÁGINAS PÚBLICAS
                    ===================================================== */}

                <Route
                    path="/termos-de-uso"
                    element={<TermosDeUso />}
                />

                <Route
                    path="/politica-de-privacidade"
                    element={<PoliticaDePrivacidade />}
                />

                <Route
                    path="/"
                    element={
                        <PublicOnlyRoute>
                            <Login />
                        </PublicOnlyRoute>
                    }
                />

                <Route
                    path="/register"
                    element={
                        <PublicOnlyRoute>
                            <Register />
                        </PublicOnlyRoute>
                    }
                />

                <Route
                    path="/register-company"
                    element={
                        <PublicOnlyRoute>
                            <RegisterCompany />
                        </PublicOnlyRoute>
                    }
                />

                <Route
                    path="/forgot-password"
                    element={<ForgotPassword />}
                />

                <Route
                    path="/reset-password"
                    element={<ResetPassword />}
                />

                <Route
                    path="/v/:slug"
                    element={<PrivateJobPage />}
                />

                {/* =====================================================
                    ROTAS AUTENTICADAS
                    ===================================================== */}

                <Route element={<ProtectedRoute />}>

                    <Route
                        path="/dashboard-freelancer"
                        element={<DashboardFreelancer />}
                    />

                    <Route
                        path="/freelancer-wallet"
                        element={<Earnings />}
                    />

                    <Route
                        path="/dashboard-company"
                        element={<DashboardCompany />}
                    />

                    <Route
                        path="/painel-profissional"
                        element={<PainelProfissional />}
                    />

                </Route>

                {/* =====================================================
                    ADMIN
                    ===================================================== */}

                <Route element={<AdminRoute />}>

                    <Route
                        path="/dashboard-admin"
                        element={<DashboardAdmin />}
                    />

                </Route>

            </Routes>
        </BrowserRouter>
    );
}